<template>
  <div v-if="isShow" class="wrapper bg_white pl15 pr15 pt15">
    <router-link v-for="(value, index) in postList" class="card" :to="{ name: 'healthTopicSingle', params: { id: value.id } }" :key="value.id">
      <div class="card_image"><img :src="imagePath + value.thumbnailPath" alt=""></div>
      <div class="title_wrap">
        <h2 class="card_title ar">{{ value.title }}</h2>
        <div class="post-date">
          <img src="@/assets/images/icon-time.png" alt="">
          <p>{{ value.updateDate }}</p>
        </div>
      </div>
    </router-link>
  </div>
  <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
</template>

<script>
import FanClub from '@/components/api/fanClub'
import Config from '@/config/config'
import Check from '@/model/getToken'

export default {
  data() {
    return {
      imagePath: Config.APIURL,
      isShow: true,
      postList: [],
    }
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      // HEALTH_TOPIC
      FanClub.getThumbnailList('HEALTH_TOPIC').then((val) => {
        this.postList.push(...val);
      });
    } else {
      this.isShow = false;
    }
  }
}
</script>

<style lang="css" scoped>
.wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.card {
  box-shadow: 0px 0 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  margin-bottom: 15px;
  overflow: hidden;
  width: 47.5%;
}
.card_image {
  display: block;
  position: relative;
}

.card_image::before {
  content: "";
  display: block;
  padding-top: 75%;
}

.card_image img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.title_wrap {
  padding: 5px 5px 15px;
}
.card_title {
  font-size: 16px;
}

.post-date{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #c1c1c1;
  font-size: 12px;
  margin-top: 5px;
}

.post-date img{
  max-width: 15px;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/fanClub/healthTopic/PostList.vue